/**
 * Enum type for Feature names in mobile-center.
 * We've strongly typed the `isActive` func of the featuresStore.
 * This will enable us to freely use feature names without the fear of typos.
 * Key = name you like, we recommend using the same as the value
 * Value = the value as found on Optimizely.com
 */
export const enum OptimizelyFeatureNames {
  // Shell
  portal_show_nps_survey = "portal_show_nps_survey",
  portal_revoke_aad_auth = "portal_revoke_aad_auth",
  portal_revoke_github_auth = "portal_revoke_github_auth",
  portal_revoke_google_auth = "portal_revoke_google_auth",
  portal_revoke_facebook_auth = "portal_revoke_facebook_auth",
  // Build
  build_secure_files_xamarin = "build_secure_files_xamarin",
  // Data
  cosmos_db_metrics = "cosmos_db_metrics",
  // Data Explorer
  cosmos_data_explorer = "cosmos_data_explorer",
  // Data Explorer CRUD
  cosmos_data_explorer_crud = "cosmos_data_explorer_crud",
  // Diagnostics
  diagnostics_error_multiple_attachments = "diagnostics_error_multiple_attachments",
  diagnostics_symbol_upload_ui_everywhere = "diagnostics_symbol_upload_ui_everywhere",
  // Distribute
  portal_upload_releases_to_azure = "portal_upload_releases_to_azure",
  // Push
  portal_push_one_signal = "portal_push_one_signal",
  // MBaaS
  market_fit_survey = "market_fit_survey",
  mbaas_optional_visibility = "mbaas_optional_visibility",
  mbaas_deprecation_banners = "mbaas_deprecation_banners",
  // Service Desk
  service_desk = "service_desk",
  cosmos_db_latency = "cosmos_db_latency",
  portal_server_internal_calls_use_gateway = "portal_server_internal_calls_use_gateway"
}

export const enum OptimizelyExperimentNames {
  "" = "" // required to type as string enum, remove when adding entries
}

export const enum OptimizelyEventNames {
  "" = "" // required to type as string enum, remove when adding entries
}

export interface OptimizelyCustomAttributes {
  internalUser: boolean;
  environment?: string;
  origin: string;
}
